var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4289 14.5712C14.6436 14.3565 14.9916 14.3565 15.2063 14.5712L25.5713 24.9362C25.786 25.1508 25.786 25.4989 25.5713 25.7136C25.3566 25.9282 25.0086 25.9282 24.7939 25.7136L14.4289 15.3486C14.2143 15.1339 14.2143 14.7858 14.4289 14.5712Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.571 14.5712C25.7857 14.7858 25.7857 15.1339 25.571 15.3485L15.206 25.7135C14.9914 25.9282 14.6433 25.9282 14.4287 25.7135C14.214 25.4989 14.214 25.1508 14.4287 24.9361L24.7937 14.5712C25.0083 14.3565 25.3564 14.3565 25.571 14.5712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a3cd0f214af841ce3c59fde18d88837c.svg";
export { ForwardRef as ReactComponent };